import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showMenu: false,
    currentRoute: '',
    news: [],
    catalog: []
  },
  mutations: {
    setCatalog (state, catalog) {
      state.catalog = catalog
      sessionStorage.setItem('kana_catalog', JSON.stringify(catalog))
    },
    addProsLists (state, {categoryId, list}) {
      state.prosLists[categoryId] = list
      sessionStorage.setItem('kana_pro', JSON.stringify(list))
    },
    setNews (state, payload) {
      state.news = payload
      sessionStorage.setItem('kana_news', JSON.stringify(payload))
    },
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js